import React from 'react';
import { Shield, Lock, Eye, FileText, CheckCircle, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        
        <button 
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center gap-2 text-gray-600 hover:text-[#1e3a5f] transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Back</span>
        </button>

        <div className="text-center mb-10">
          <div className="flex justify-center mb-4">
            <Shield className="text-[#1e3a5f]" size={48} />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">Privacy Policy</h1>
          <p className="text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString()}</p>
          <div className="w-20 h-1 bg-[#1e3a5f] mx-auto mt-4 rounded-full"></div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <p className="text-gray-700 leading-relaxed">
            DP Jewellers is committed to ensuring that your privacy is protected. 
            This policy explains how we use the information we collect about you.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-[#1e3a5f]/10 p-2 rounded-lg">
              <FileText className="text-[#1e3a5f]" size={24} />
            </div>
            <h2 className="text-xl font-bold text-gray-800">Information We Collect</h2>
          </div>
          <p className="text-gray-700 leading-relaxed mb-3">
            We may collect personal information such as:
          </p>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Your name</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Email address</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Phone number</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Shipping address</span>
            </li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            This information is collected when you make a purchase or sign up for our newsletter.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-[#1e3a5f]/10 p-2 rounded-lg">
              <Eye className="text-[#1e3a5f]" size={24} />
            </div>
            <h2 className="text-xl font-bold text-gray-800">How We Use Information</h2>
          </div>
          <p className="text-gray-700 leading-relaxed mb-3">
            We use this information to:
          </p>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Process your orders</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Communicate with you about your order</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle size={18} className="text-green-500 mt-0.5" />
              <span className="text-gray-700">Send you promotional offers (if you have opted in)</span>
            </li>
          </ul>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="bg-[#1e3a5f]/10 p-2 rounded-lg">
              <Lock className="text-[#1e3a5f]" size={24} />
            </div>
            <h2 className="text-xl font-bold text-gray-800">Data Security</h2>
          </div>
          <p className="text-gray-700 leading-relaxed">
            We use a variety of security measures to maintain the safety of your personal information 
            when you place an order or enter, submit, or access your personal information.
          </p>
        </div>
        <div className="bg-blue-50 rounded-xl p-6 mb-6 border border-blue-100">
          <h3 className="font-semibold text-[#1e3a5f] mb-2">Need More Information?</h3>
          <p className="text-gray-700 text-sm mb-3">
            If you have any questions about our privacy policy, please contact us:
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a 
              href="tel:+918953786652"
              className="inline-flex items-center gap-2 text-[#1e3a5f] hover:text-[#153057] text-sm"
            >
              📞 +91 89537 86652
            </a>
            <a 
              href="mailto:info@dpjewellersballia.in"
              className="inline-flex items-center gap-2 text-[#1e3a5f] hover:text-[#153057] text-sm"
            >
              ✉️ info@dpjewellersballia.in
            </a>
          </div>
        </div>
        <div className="text-center text-gray-400 text-xs mt-8">
          <p>DP Jewellers - Trusted Since 1941</p>
          <p className="mt-1">© {new Date().getFullYear()} DP Jewellers. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;